import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUser } from 'app/shared/models/users.model';
import { ICredentials } from 'app/shared/models/credentials.model';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';


@Injectable({
  providedIn: 'root'
})
export class ImpersonateService {

  impersonatedUser!: IUser | null;

  constructor(private http: HttpClient, private location: Location, private helperService: HelperService) { }

  getUsers(data: DataTableStateModel): Observable<IUser[]> {
    data = this.helperService.replaceFilterBlanksSelection(data);

    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false,
      orderField: data.sortingValue.prop ? data.sortingValue.prop : undefined,
      fieldFilters: data.datatableFilters || []
    };

    return this.http.post<IUser[]>(`/v1/user-management/impersonate-users/search`, params);

  }

  getImpersonatedUserCredentials(): ICredentials | undefined {
    if (this.impersonatedUser) {
      return { id: this.impersonatedUser.id, email: this.impersonatedUser.email, fullName: this.impersonatedUser.fullName, role: this.impersonatedUser.role }
    }
    return undefined;
  }

  startImpersonation(user: IUser): void {
    if (!user.email) {
      return;
    }

    sessionStorage.setItem('impersonatedUser', JSON.stringify(user));
    this.location.replaceState('admin');
    location.reload();
  }


  stopImpersonation(): void {
    this.impersonatedUser = null;
    sessionStorage.removeItem('impersonatedUser');
    this.location.replaceState('admin/impersonate-user');
    location.reload();
  }
}
